import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './Blur.module.css';
import isSafari from '../../utils/methods/isSafari';

const bindClasses = classNameBind.bind(styles);

const Blur = ({ children, visibleContent, backgroundImage }) => (
  <div
    className={bindClasses('blur-container')}
    data-ppuc-id="Blur"
  >
    {children}
    <div className={bindClasses('blur-overlay', isSafari() && 'isSafari')}>
      <div
        data-ppuc-id="Blur-Inner"
        className={bindClasses('blur-inner', `background-image-${backgroundImage}`)}
      >
        {visibleContent}
      </div>
    </div>
  </div>
);

Blur.defaultProps = {
  backgroundImage: 'none',
  withBorder: false,
};

export default Blur;
